import type { SpotGeometry } from "../../src/image/placement.ts";
import type { Offset } from "../../src/lib/offset.ts";
import { previewBox } from "./cart.ts";

// Moves one logo overlay onto its spot on the photo shown (the server places the logo the same way), or hides it
// while there is nothing to place yet. The offset (already clamped) moves it within the spot.
export function placeOverlay(
  overlay: HTMLElement | null,
  geo: SpotGeometry | undefined,
  ppi: number,
  size: { widthIn: number; heightIn: number } | null,
  photo: { w: number; h: number } | undefined,
  offset?: Partial<Offset>,
): void {
  if (!overlay) return;
  if (!geo || !size || !photo) {
    overlay.style.display = "none";
    return;
  }
  Object.assign(overlay.style, { display: "block", ...previewBox(geo, ppi, size.widthIn, size.heightIn, photo.w, photo.h, offset) });
}
